import React, { PropsWithChildren } from 'react';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';

import { bisTheme } from '../../styles/themes';

interface ThemeProviderProps extends PropsWithChildren {
  pathname?: string;
}

const ThemeProvider = ({ children, pathname }: ThemeProviderProps) => (
  <StyledComponentsThemeProvider theme={bisTheme}>
    {children}
  </StyledComponentsThemeProvider>
);

export default ThemeProvider;
